module.exports = __webpack_public_path__ + "72d40e1c.png";